import type { Property } from 'csstype';
import type { Position } from 'geojson';
import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { type LngLatLike, useMap } from 'react-map-gl/mapbox';
import { withMap } from '../with-map.js';
import { MapView } from './view.js';

interface Props {
  center?: Position | null;
  height?:
    | Property.Height<string | number>
    | NonNullable<Property.Height<string | number> | undefined>[]
    | undefined;
  initialZoom?: number;
  interactive?: boolean;
  mapStyle: string;
  minHeight?:
    | Property.Height<string | number>
    | NonNullable<Property.Height<string | number> | undefined>[]
    | undefined;
  minWidth?:
    | Property.Width<string | number>
    | NonNullable<Property.Width<string | number> | undefined>[]
    | undefined;
  width?:
    | Property.Width<string | number>
    | NonNullable<Property.Width<string | number> | undefined>[]
    | undefined;
}

export const CenterMiniMap: FC<PropsWithChildren<Props>> = withMap(
  ({ center, ...props }) => {
    const { default: map } = useMap();

    useEffect(() => {
      if (!center) return;
      map?.flyTo({ center: center as LngLatLike });
    }, [map, center]);

    const initialViewState = {
      latitude: center?.[1],
      longitude: center?.[0],
      zoom: props.initialZoom ?? 16,
    };

    return MapView({
      ...props,
      initialViewState,
    });
  },
);
